// Quick Quote Mini — Web3Forms integration + Phone Mask + Append Ext to Phone
(function(){
  document.querySelectorAll('[data-qqm]').forEach((root) => {
    const btn         = root.querySelector('.qqm-btn');
    const panel       = root.querySelector('.qqm-panel');
    const closeBtn    = root.querySelector('.qqm-close');
    const step1       = root.querySelector('.qqm-step[data-step="1"]');
    const step2       = root.querySelector('.qqm-step[data-step="2"]');
    const goLink      = root.querySelector('[data-qqm-go]');
    const continueBtn = root.querySelector('[data-qqm-continue]');
    const backBtn     = root.querySelector('[data-qqm-back]');
    const stoneSelect = root.querySelector('select.qqm-select');
    const successBox  = root.querySelector('[data-qqm-success]');
    const errorBox    = root.querySelector('[data-qqm-error]');
    const form        = root.querySelector('form[data-web3forms]');
    const phoneInput  = root.querySelector('[data-phone-mask]');
    const extInput    = root.querySelector('#' + (phoneInput ? phoneInput.id.replace('phone', 'phone-ext') : ''));

    if (!btn || !panel) return;

    // --- Helpers ---
    function getWeb3Key() {
      if (!form) return '';
      // 1) hidden input <input name="access_key" value="...">
      const hidden = form.querySelector('input[name="access_key"]');
      if (hidden && hidden.value) return hidden.value.trim();
      // 2) data attribute on the form: data-web3forms-key="..."
      if (form.dataset.web3formsKey) return form.dataset.web3formsKey.trim();
      // 3) data attribute on the root container
      if (root.dataset.web3formsKey) return root.dataset.web3formsKey.trim();
      // 4) global from theme injected script
      if (typeof window !== 'undefined' && window.WEB3FORMS_KEY) return String(window.WEB3FORMS_KEY).trim();
      return '';
    }

    function openPanel() {
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      btn.setAttribute('aria-expanded', 'true');
      trapFocus(panel);
    }
    function closePanel() {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      btn.setAttribute('aria-expanded', 'false');
    }

    btn.addEventListener('click', (e)=>{ e.preventDefault(); openPanel(); });
    closeBtn && closeBtn.addEventListener('click', closePanel);
    root.addEventListener('keydown', (e)=>{ if(e.key === 'Escape') closePanel(); });

    continueBtn && continueBtn.addEventListener('click', ()=> {
      step1 && step1.classList.remove('is-active');
      step2 && step2.classList.add('is-active');
    });
    backBtn && backBtn.addEventListener('click', ()=> {
      step2 && step2.classList.remove('is-active');
      step1 && step1.classList.add('is-active');
    });

    // Stone selection link enablement
    function updateGoLink(){
      const url = stoneSelect && stoneSelect.value || '';
      if(url){
        goLink.setAttribute('href', url);
        goLink.removeAttribute('disabled');
        goLink.style.opacity = '1';
        goLink.style.pointerEvents = 'auto';
      } else {
        goLink.setAttribute('href', '#');
        goLink.setAttribute('disabled', 'true');
        goLink.style.opacity = '.5';
        goLink.style.pointerEvents = 'none';
      }
    }
    if (stoneSelect && goLink) {
      updateGoLink();
      stoneSelect.addEventListener('change', updateGoLink);
    }

    // Phone input mask: (xxx) -xxx-xxxx
    function formatUSPhone(raw) {
      const digits = (raw || '').replace(/\D/g, '').slice(0, 10);
      const len = digits.length;
      if (len === 0) return '';
      if (len < 4)  return `(${digits}`;
      if (len < 7)  return `(${digits.slice(0,3)}) -${digits.slice(3)}`;
      return `(${digits.slice(0,3)}) -${digits.slice(3,6)}-${digits.slice(6)}`;
    }
    if (phoneInput) {
      phoneInput.addEventListener('input', () => {
        const caretAtEnd = phoneInput.selectionStart === phoneInput.value.length;
        phoneInput.value = formatUSPhone(phoneInput.value);
        if (caretAtEnd) phoneInput.selectionStart = phoneInput.selectionEnd = phoneInput.value.length;
      });
      phoneInput.addEventListener('paste', () => {
        setTimeout(() => { phoneInput.value = formatUSPhone(phoneInput.value); });
      });
      phoneInput.addEventListener('blur', () => {
        phoneInput.value = formatUSPhone(phoneInput.value);
      });
    }

    // Web3Forms AJAX submit (auto-includes access_key)
    if (form) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (errorBox) { errorBox.classList.remove('is-show'); errorBox.style.display = 'none'; }
        if (successBox) successBox.classList.remove('is-show');

        // Required fields: project, name, email, phone
        const required = ['project','name','email','phone'];
        for (const name of required) {
          const el = form.querySelector(`[name="${name}"]`);
          if (!el || !el.value.trim()) {
            if (errorBox) {
              errorBox.textContent = 'Please fill required fields (Name, Phone, Email Address, What are you working on?).';
              errorBox.classList.add('is-show');
              errorBox.style.display = 'block';
            }
            return;
          }
        }

        // Ensure we have an access key
        const accessKey = getWeb3Key();
        if (!accessKey) {
          if (errorBox) {
            errorBox.textContent = 'Missing Web3Forms access key. Add it in theme settings or as data-web3forms-key/access_key field.';
            errorBox.classList.add('is-show');
            errorBox.style.display = 'block';
          }
          return;
        }

        try {
          const fd = new FormData(form);

          // Put access key into payload unless already present
          if (!fd.get('access_key')) fd.set('access_key', accessKey);

          // Append Ext to Phone before sending
          const phoneVal = (fd.get('phone') || '').toString().trim();
          const extVal   = (fd.get('phone_ext') || '').toString().trim();
          if (extVal) {
            fd.set('phone', `${phoneVal} x${extVal}`);
          }
          // Optional: if you do not want phone_ext as a separate field in your inbox
          // fd.delete('phone_ext');

          // Default endpoint if none set on the form
          const endpoint = form.getAttribute('action') || 'https://api.web3forms.com/submit';

          const res = await fetch(endpoint, {
            method: 'POST',
            body: fd,
            headers: { 'Accept': 'application/json' }
          });
          const data = await res.json();

          if (data && (data.success === true || data.message === 'Submission successful')) {
            if (successBox) successBox.classList.add('is-show');
            form.reset();
          } else {
            throw new Error(data && data.message ? data.message : 'Unknown error');
          }
        } catch (err) {
          if (errorBox) {
            errorBox.textContent = 'There was a problem sending your request. ' + err.message;
            errorBox.classList.add('is-show');
            errorBox.style.display = 'block';
          }
        }
      });
    }

    function trapFocus(node){
      const s = 'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])';
      const focusables = Array.from(node.querySelectorAll(s)).filter(el => !el.hasAttribute('disabled') && el.getAttribute('aria-hidden') !== 'true');
      if(!focusables.length) return;
      const first = focusables[0], last = focusables[focusables.length - 1];
      first.focus();
      function onKey(e){
        if(e.key !== 'Tab') return;
        if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
        else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
      }
      node.addEventListener('keydown', onKey);
    }
  });
})();
